export type MeaningSwipeStep = -1 | 0 | 1;

type MeaningSwipe = {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  durationMs: number;
};

export function meaningSwipeStep({
  startX,
  startY,
  endX,
  endY,
  durationMs,
}: MeaningSwipe): MeaningSwipeStep {
  const deltaX = endX - startX;
  const deltaY = endY - startY;
  const horizontalDistance = Math.abs(deltaX);
  const verticalDistance = Math.abs(deltaY);

  if (
    durationMs > 520
    || horizontalDistance < 52
    || horizontalDistance < verticalDistance * 1.35
  ) {
    return 0;
  }

  return deltaX < 0 ? 1 : -1;
}

export function moveMeaningIndex(
  current: number,
  meaningCount: number,
  step: MeaningSwipeStep,
) {
  if (meaningCount <= 0) return 0;
  return Math.max(0, Math.min(meaningCount - 1, current + step));
}
